import { orchestrator } from 'satcheljs';
import { onCopilotChatDrawerReady } from 'owa-copilot-chat-drawer-store';
import tryRunPendingAutoOpenOperation from '../utils/tryRunPendingAutoOpenOperation';
import { isBizchatSidepaneEnabled } from 'owa-bizchat-shared/lib/utils/isBizchatSidepaneEnabled';

// Once the Chat Drawer is rendered, trigger any pending auto-open operation
// This is important so that we can auto-open the drawer after the container is ready
orchestrator(onCopilotChatDrawerReady, () => {
    if (isBizchatSidepaneEnabled()) {
        tryRunPendingAutoOpenOperation();
    }
});
